<template>
  <a-spin :spinning="spinning">
    <van-nav-bar :right-text="username" left-arrow left-text="返回" @click-left="onClickLeft" @click-right="goIndex()"/>
    <van-tabs ref="tabs" v-model="active">
      <van-tab name="0" title="详情">
        <div v-if="device">
          <van-field :value="packingPosition.name" label="打包位" name="PackingPositionsPicker" readonly right-icon="clear" @focus="showPackingPosition=true" @click-right-icon="clearPackingPosition"/>
          <van-popup v-model="showPackingPosition" position="bottom">
            <van-picker :columns="packingPositions" show-toolbar value-key="name" @cancel="showPackingPosition = false" @confirm="onPackingPositionSelected"/>
          </van-popup>
        </div>
        <div v-if="!special">
          <van-field v-if="device" ref="containerNo" v-model="containerNo" label="周转箱号" name="周转箱号" @keyup="onNoScanned"/>
          <van-field v-if="!device" ref="containerNo" v-model="pickingOrderNo" label="拣货单号" name="拣货单号" @keyup="onNoScanned"/>
        </div>
        <van-field ref="item_no" v-model="itemNo" clearable label="商品编号" name="商品编号" @keyup="onItemNo"/>
        <van-field v-model="detail.item.name" label="通用名称" name="通用名称" readonly/>
        <van-field v-model="detail.customer.shortName" error label="客户简称" name="客户简称" readonly/>
        <van-field v-model="detail.pack.specification" label="规格" name="规格" readonly/>
        <van-field v-model="detail.pack.uom" label="计量单位" name="计量单位" readonly/>
        <van-field v-model="detail.pack.factor" label="包装数" name="包装数" readonly/>
        <van-field v-model="detail.lot.no" label="批号" name="批号" readonly/>
        <van-field v-model="detail.lot.productionDate" label="生产日期" name="生产日期" readonly/>
        <van-field v-model="detail.lot.validUntil" label="有效期" name="有效期" readonly/>
        <van-field v-model="detail.lot.manufacturer" label="生产厂商" name="生产厂商" readonly/>
        <van-field v-model="detail.lot.producingArea" label="产地" name="产地" readonly/>
        <van-field v-model="detail.lot.approvalNo" label="批准文号" name="批准文号" readonly/>
        <van-row>
          <van-col span="8">
            <van-cell center title="监管">
              <van-switch slot="right-icon" v-model="detail.command.supervised" active-color="#07c160" disabled inactive-color="#dcdee0" size="24"/>
            </van-cell>
          </van-col>
          <van-col span="8">
            <van-cell center title="易碎">
              <van-switch slot="right-icon" v-model="detail.item.fragile" active-color="#07c160" disabled inactive-color="#dcdee0" size="24"/>
            </van-cell>
          </van-col>
          <van-col span="8">
            <van-cell center title="追加">
              <van-switch slot="right-icon" v-model="detail.appending" active-color="#07c160" inactive-color="#dcdee0" size="24"/>
            </van-cell>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="12">
            <van-field v-model="detail.command.plannedQuantity" label="计划数量" name="计划数量" readonly/>
          </van-col>
          <van-col span="12">
            <van-field v-model="detail.command.actualQuantity" clearable error label="实际数量" name="实际数量" type="number"/>
          </van-col>
        </van-row>
        <van-tabbar fixed placeholder>
          <van-tabbar-item>
            <van-button block round style="margin: 8px;" type="info" @click="supervise">监管</van-button>
          </van-tabbar-item>
          <van-tabbar-item>
            <van-button block round style="margin: 8px;" type="primary" @click="save">保存</van-button>
          </van-tabbar-item>
        </van-tabbar>
      </van-tab>
      <van-tab name="1" title="清单">
        <div style="height: 60%">
          <vxe-table
            border
            ref="tasks"
            round
            :data="tasks"
            show-overflow
            :loading="loading"
            :export-config="{}"
            :radio-config="{trigger: 'row'}"
            :row-config="{isCurrent: true, isHover: true}"
            :column-config="{resizable: true}"
            align="center"
            :keyboard-config="{isArrow: true}"
            :scroll-x="{enabled: true}"
            size="mini"
            show-header-overflow
            stripe>
            <vxe-column field="command.commandStatus" title="business.label.commandStatus" width="100">
              <span slot-scope="{ row }">{{commandStatus.find(item => item.ordinal === row.command.commandStatus).name}}</span>
            </vxe-column>
            <vxe-column field="barcode.no" title="business.label.groupage" width="60"/>
            <vxe-column field="item.name" title="商品名称"/>
            <vxe-column field="lot.no" title="批号" width="100"/>
            <vxe-column field="command.plannedQuantity" title="数量" width="50"/>
          </vxe-table>
        </div>
        <van-tabbar fixed placeholder>
          <van-tabbar-item>
            <van-button block round style="margin: 8px;" type="primary" @click="sealing">封箱</van-button>
          </van-tabbar-item>
          <van-tabbar-item>
            <van-button block round style="margin: 8px;" type="primary" @click="confirm">复核</van-button>
          </van-tabbar-item>
        </van-tabbar>
      </van-tab>
    </van-tabs>
  </a-spin>
</template>
<script>
import api from '@/api'
import debounce from 'lodash/debounce'
import { findAll, findEnum, post } from '@/api/Api'
import { Toast } from 'vant'
import { getOutBoundEachData, getUser, removeNullValues } from '@/pdaView/utils'
import { ShippingFactoryView } from '@/api/dto/view/ShippingFactoryView'

export default {
  name: 'ReviewOfPacking',
  data() {
    return {
      active: '0',
      spinning: false,
      loading: false,
      username: getUser().name,
      detail: new ShippingFactoryView(),
      containerNo: '',
      itemNo: '',
      tasks: [],
      packingPosition: { id: '', name: '' },
      packingPositions: [],
      showPackingPosition: false,
      commandStatus: []
    }
  },
  created() {
    findEnum('CommandStatus').then(res => {
      if (res.success) {
        this.commandStatus = res.result
      }
    })
    if (this.positionType !== null && this.positionType !== undefined) {
      findAll('locationFactory', { 'positionType.id': this.positionType.id }).then(res => {
        if (res.success) {
          this.packingPositions = res.result
        }
      })
    }
  },
  activated() {
    if (this.special === true) {
      this.obtain()
    }
  },
  computed: {
    pickingOrderNo() {
      return this.$route.params.pickingOrderNo
    },
    special() {
      return this.$route.params.special ? this.$route.params.special : false
    },
    positionType() {
      return this.$route.meta.positionType ? this.$route.meta.positionType : null
    },
    device() {
      return this.$route.meta.device
    },
    entire() {
      return this.$route.meta.entire
    }
  },
  methods: {
    goIndex() {
      this.$router.push({ name: 'PdaIndex' })
    },
    onClickLeft() {
      if (this.special) {
        this.$router.push({ name: 'SpecialHall' })
      } else {
        this.goIndex()
      }
    },
    clearPackingPosition() {
      this.packingPosition = { id: '', name: '' }
    },
    onPackingPositionSelected(item) {
      this.packingPosition = item
      this.showPackingPosition = false
      this.$refs.containerNo.focus()
    },
    onItemNo: debounce(function(data) {
      if ([13].includes(data.keyCode)) {
        const value = _.trim(data.target.value)
        this.review(value)
      }
    }, 300),
    review(data) {
      if (data) {
        let results = this.tasks.filter(row => row.item.no.includes(data) || row.item.mnemonicCode.includes(data) || row.item.barcodes.includes(data))
        if (results.length > 0 && results[0].command.commandStatus === 36) {
          this.spinning = true
          const ids = results.map(row => row.command.id)
          post(api.packingObtain, { type: 'commandObtainer' }, { ids: ids }).then(res => {
            if (res.success) {
              this.refresh()
              results = this.tasks.filter(row => row.item.no.includes(data) || row.item.mnemonicCode.includes(data) || row.item.barcodes.includes(data))
              Object.assign(this.detail, removeNullValues(results[0]))
            }
          }).finally(() => this.spinning = false)
        } else {
          Toast('未找到条码对应的任务！')
        }
      } else {
        Toast('商品编号不能为空！')
      }
    },
    onNoScanned: debounce(function(data) {
      if ([13].includes(data.keyCode)) {
        const value = _.trim(data.target.value)
        this.obtain(value)
      }
    }, 300),
    obtain() {
      this.detail=new ShippingFactoryView()
      this.itemNo=null
      if (!this.special) {
        if (this.device) {
          if (!this.containerNo) {
            Toast('请输入周转箱号！')
            return
          }
        } else {
          if (!this.pickingOrderNo) {
            Toast('请输入拣货单号！')
            return
          }
        }
      }
      this.spinning = true
      let args = {
        'position.id': this.packingPosition.id,
        'container.no': this.containerNo,
        'pickingOrder.no': this.pickingOrderNo,
        'entire': this.entire
      }
      post(api.packingObtain, { type: this.device ? 'containerObtainer' : 'pickingOrderObtainer' }, args).then(res => {
        if (res.success) {
          this.refresh()
        }
      }).finally(() => this.spinning = false)
    },
    refresh() {
      if (!this.special) {
        if (this.device) {
          if (!this.containerNo) {
            Toast('请输入周转箱号！')
            return
          }
        } else {
          if (!this.pickingOrderNo) {
            Toast('请输入拣货单号！')
            return
          }
        }
      }
      const args = {
        'container.no': this.device ? this.containerNo : undefined,
        'pickingOrder.no': this.device ? undefined : this.pickingOrderNo,
        commandStatus: ['PACKING_OBTAINED', 'ITEM_REVIEWED']
      }
      this.loading = true
      findAll('packingTaskDetailFactory', args).then(res => {
        if (res.success) {
          if (res.result.length === 0) {
            if (this.special) {
              this.$refs.item_no.focus()
            } else {
              this.$refs.containerNo.focus()
            }
          } else {
            res.result.map(item => {
              item.appending = item.command.appendageSign === 1
            })
            this.tasks = res.result
          }
        }
      }).finally(() => this.loading = false)
    },
    save() {
      if (!this.detail.command.id) {
        Toast('无数据保存！')
        return
      }
      const args = {
        id: this.detail.command.id,
        actualQuantity: this.detail.command.actualQuantity,
        appendageSign: this.detail.appending === true ? 1 : 3
      }
      this.spinning = true
      post(api.packingCount, {}, args).then(res => {
        if (res.success) {
          Toast('保存成功！')
          this.refresh()
        }
      }).finally(() => this.spinning = false)
    },
    sealing() {
      const row = this.tasks.find(row => row.barcode === null || row.barcode.id === null)
      if (!row) {
        Toast('没有可以封箱的数据')
        return
      }
      const args = {
        'command.id': row.command.id
      }
      this.spinning = true
      post(api.packingSealing, {}, args).then(res => {
        if (res.success) {
          Toast('封箱成功！')
          this.refresh()
        }
      }).finally(() => this.spinning = false)
    },
    confirm() {
      const data = {
        'container.no': this.containerNo,
        'pickingOrder.no': this.pickingOrderNo
      }
      this.spinning = true
      post(api.packingConfirm, { type: this.device ? 'containerConfirmer' : 'pickingOrderConfirmer' }, data).then(res => {
        if (res.success) {
          Toast('复核成功！')
          if (this.special === true) {
            this.onClickLeft()
          } else {
            this.active = '0'
            this.containerNo = ''
            this.pickingOrderNo = ''
            this.itemNo = ''
            this.detail = new ShippingFactoryView()
            this.$refs.containerNo.focus()
          }
        }
      }).finally(() => this.spinning = false)
    },
    supervise() {
      if (this.detail.command.supervised) {
        this.$router.push({ name: 'SupervisionCode', params: { parent: 'ReviewOfPacking', command: this.detail.command, pack: this.detail.pack } })
      }
    },
    printData(barcodeNo) {
      let args = {
        'query.no': 'eachPickingTagPrint',
        sql: null,
        args: {
          barcodeNo: barcodeNo
        }
      }
      getOutBoundEachData(args)
    }
  }
}
</script>